import { useMutation } from '@tanstack/react-query';

import { resendEmailOtpApi } from '../api';

export default function useValidateEmailMutation(config?: any) {
  return useMutation(resendEmailOtpApi, config);
}
